// extracted by mini-css-extract-plugin
export default {"heading":"SummaryLedgers_heading__BQCZ+","title":"SummaryLedgers_title__AwYFE","period":"SummaryLedgers_period__xkwHo"};